import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IPartnerReceivables } from "../domain/IPartnerReceivables";
import { IReceivedPayment } from "../domain/IReceivedPayment";
import { DailyTableService } from "../services/dt.service";

interface dtReceivablesState {
  loading: boolean;
  remainingReceivableAmount: number;
  receivedPayments: IReceivedPayment[];
  error: any;
}

const initialState: dtReceivablesState = {
  loading: false,
  remainingReceivableAmount: 0,
  receivedPayments: [],
  error: undefined,
};

export const getPartnerReceivablesWithPayments = createAsyncThunk(
  "DailyTable/getPartnerReceivablesWithPayments",
  async () => {
    try {
      const result =
        await DailyTableService.getPartnerReceivablesWithPayments();
      return result;
    } catch (err) {
      setError(err);
    }
  }
);

export const dtReceivablesSlice = createSlice({
  name: "Receivables",
  initialState: initialState,
  reducers: {
    setReceivables: (state, action: PayloadAction<IPartnerReceivables>) => {
      state.remainingReceivableAmount =
        action.payload.remainingReceivableAmount;
      state.receivedPayments = action.payload.receivedPayments;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPartnerReceivablesWithPayments.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getPartnerReceivablesWithPayments.fulfilled,
      (state, action) => {
        state.remainingReceivableAmount = action.payload
          ?.remainingReceivableAmount
          ? action.payload?.remainingReceivableAmount
          : 0;
        state.receivedPayments = action.payload?.receivedPayments
          ? action.payload.receivedPayments
          : [];
        state.loading = false;
      }
    );
    builder.addCase(
      getPartnerReceivablesWithPayments.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    );
  },
});

export const selectState = (state: RootState) => state.dailytable.receivables;

export const { setError } = dtReceivablesSlice.actions;

export default dtReceivablesSlice.reducer;
